const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5"><defs></defs><title>tablet-1</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M3.744 18.75h16.5"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M5.247.75h13.5s1.5 0 1.5 1.5v19.5s0 1.5-1.5 1.5h-13.5s-1.5 0-1.5-1.5V2.25s0-1.5 1.5-1.5"></path></svg>';
export {
  e as default
};
